import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useTranslation } from "react-i18next";
import {
  faBed,
  faBookUser,
  faCreditCard,
  faGiftCard,
  faMoneyBillWave,
  faMoneyCheckDollar,
} from "@fortawesome/pro-regular-svg-icons";

import "elements/register/register.scss";

import Radio from "components/radio/index";
import MessageDisplay from "components/messageDisplay/MessageDisplay";
import { getCreditCardIcon } from "helpers/Helpers";
import { faFileUser } from "@fortawesome/pro-duotone-svg-icons";
import { ICustomer } from "redux/reducers/models/customer";

interface IProps {
  onChange?: (paymentOption: Record<string, any>) => void;
  paymentOptions: Record<string, any>[];
  cardReaderAvailable?: boolean;
  cart: any;
  customer?: ICustomer;
  paymentAmount: number;
  darkStyle?: boolean;
  value?: Record<string, any>;
  manualOnly?: boolean;
  allowDeselect?: boolean;
}

export default function PaymentMethods(props: IProps) {
  const { t } = useTranslation();
  // Function to get the icon based on payment type value
  const getPaymentIcon = (paymentMethod: string) => {
    switch (paymentMethod?.toLowerCase()) {
      case "interac":
        return faCreditCard;
      case "visa":
        return getCreditCardIcon(paymentMethod);
      case "mastercard":
        return getCreditCardIcon(paymentMethod);
      case "discover":
        return getCreditCardIcon(paymentMethod);
      case "gift_card":
        return faGiftCard;
      case "account":
        return faFileUser;
      case "cash":
        return faMoneyBillWave;
      case "cheque":
      case "check":
        return faMoneyCheckDollar;
      case "moneris":
        return getCreditCardIcon(paymentMethod);
      case "credit_book":
        return faBookUser;
      case "manual_card":
        return getCreditCardIcon(paymentMethod);
      case "room_charge_rdp":
      case "room_charge_maestro":
      case "folio_charge":
        return faBed;
      case "card":
        return getCreditCardIcon(paymentMethod);
      case "amex":
        return getCreditCardIcon(paymentMethod);
      default:
        return faMoneyBillWave;
    }
  };

  return (
    <div>
      {props.paymentOptions.length >= 1 ? (
        <Radio.Group
          onChange={value => props.onChange?.(value as Record<string, any>)}
          allowDeselect={props.allowDeselect}
          type={3}
          className="flex-row flex-wrap"
          // defaultValue={props.paymentOptions?.find(paymentOption => paymentOption.payment_method === "cash")}
          value={props.value}
          darkStyle={props.darkStyle ? true : false}
        >
          {props.paymentOptions.length >= 1 &&
            props.paymentOptions.map((paymentOption: any) => {
              return (
                <Radio.Button
                  disabled={
                    props.paymentAmount < 0 && paymentOption.payment_method !== "account"
                      ? true
                      : !props.cardReaderAvailable && paymentOption.processing_type === "terminal"
                      ? true
                      : paymentOption.payment_method === "folio_charge" && !props.cart?.customer
                      ? true
                      : (paymentOption.payment_method === "card" || paymentOption.payment_method === "manual_card") &&
                        props.paymentAmount < 0.5
                      ? true
                      : props.manualOnly &&
                        (paymentOption.type !== "manual" ||
                          paymentOption.payment_method === "gift_card" ||
                          paymentOption.payment_method === "credit_book") // Temporary check for invoice payments
                      ? true
                      : false
                  }
                  value={paymentOption}
                  id={paymentOption.id}
                  key={paymentOption.id}
                  icon={
                    <FontAwesomeIcon
                      fixedWidth
                      icon={getPaymentIcon(paymentOption.payment_type as string)}
                      style={{ fontSize: "14px" }}
                    />
                  }
                  paymentMethod={paymentOption.payment_method}
                >
                  <span className="flex flex-1 text-center self-center justify-self-center">{paymentOption.title}</span>
                </Radio.Button>
              );
            })}
        </Radio.Group>
      ) : (
        <div className="ui-no-payment">
          {" "}
          <MessageDisplay
            icon={"circle-exclamation"}
            content={t("Please activate a payment method")}
            title={t("No Active Payment Methods")}
          />{" "}
        </div>
      )}
    </div>
  );
}
